<template>
  <div>
    <div class="" v-loading="loading">
      <el-upload class="avatar-uploader" :action="$uploadURL" :show-file-list="false" :on-success="handleSuccess"
        :before-upload="beforeAvatarUpload" :disabled="disabled">
        <div v-if="imgURL" class="flex">
          <div style="margin: 5px" class="imgBox">
            <img :src="imgURL" class="avatar" alt="" />
            <div class="img-icon">
              <i class="el-icon-zoom-in" @click.stop="openElImageViewer(imgURL)"></i>
              <i class="el-icon-delete" @click.stop="handelRemove(text)"></i>
            </div>
          </div>
        </div>
        <i v-else @click="uploadPicture('listtt')" class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </div>
    <ElImageViewer v-if="showElImageViewer" :zIndex="8000" :src="Elimgs" :on-close="handleCloseElImageViewer"
      :url-list="[Elimgs]"></ElImageViewer>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  components: { ElImageViewer },
  props: {
    imgURL: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    previewImgList: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ''
    },
    flag: {
      type: Number,
      default: 0
    }
  },
  mounted () {
    console.log(this.imgURL, 65)
  },
  data () {
    return {
      loading: false,
      dialogImageUrl: '',
      dialogVisibleImg: false,
      preIniIndex: 0, // 初始化展示哪张图片
      showViewer: false, // 显示查看器
      // previewImgList: [] // 预览图片列表
      Elimgs: '',
      showElImageViewer: false
    }
  },
  methods: {
    handleCloseElImageViewer () {
      this.showElImageViewer = false
    },
    openElImageViewer (item) {
      this.Elimgs = item
      this.showElImageViewer = true
    },

    handleSuccess (res) {
      this.$emit('addImg', this.text, res.data.url)
      this.loading = false
    },
    handelRemove (text) {
      this.$emit('delImg', text)
    },
    uploadPicture (val) { },
    // 图片校验
    beforeAvatarUpload (file) {
      const ImageType =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg'

      if (!ImageType) {
        this.$message.error('上传图片只能是 JPG 、PNG 、JPEG 格式!')
      }
      return ImageType
    }

  }
}
</script>

<style lang="scss">
.imgBox {
  //width: 70px;
  height: 140px;
  position: relative;
  //margin-bottom: 5px;
}

.imgBox:hover .img-icon {
  display: flex;
}

.imgBox:hover .img-icon {
  display: flex;
}

.img-icon {
  width: 140px;
  height: 140px;
  border-radius: 6px;
  position: absolute;
  left: 0;
  top: 0;
  display: none;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: rgba(0, 0, 0, 0.4);

  i {
    font-size: 26px;
    color: #fff;
  }
}

.avatar-uploader {
  //width: 100%;
}

.avatar-uploader ::v-deep .el-upload {
  //background-color: #fbfdff;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  font-size: 28px;
  color: #8c939d;
  width: 140px;
  height: 140px;
  line-height: 140px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}

/deep/.el-loading-spinner {
  margin-top: -74px;
}

.avatar {
  display: block;
  width: 140px;
  height: 140px;
  border-radius: 6px;
}

.text {
  font-size: 12px;
  // margin-top: -17px;
  // margin-left: 40px;
}

.con {
  text-align: center;
}
</style>
